import React from "react";
import usePagination from "@mui/material/usePagination";
import makeStyles from "@mui/styles/makeStyles";
import { map } from "ramda";
import PageIcon from "@mui/icons-material/FiberManualRecord";
import PreviousIcon from "@mui/icons-material/KeyboardArrowLeft";
import NextIcon from "@mui/icons-material/KeyboardArrowRight";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";

const useStyles = makeStyles(theme => ({
  pageButton: {
    padding: theme.spacing(1),
  },

  pageIcon: {
    fontSize: ".75rem",
    lineHeight: "1.0rem",
    color: theme.palette.disabled,
  },

  selectedPageIcon: {
    fontSize: ".75rem",
    lineHeight: "1.0rem",
    color: theme.palette.primary.darker,
  },

  navButton: {
    padding: theme.spacing(1),
    color: theme.palette.primary.darker,
  },

  navIcon: {
    fontSize: "2.75rem",
    lineHeight: "1.0rem",
  },

  disabled: {
    color: theme.palette.disabled,
  },
}));

const DotPagination = ({
  totalCount,
  itemsPerPage = 4,
  page,
  onPageSelect,
}) => {
  const classes = useStyles();
  const { items } = usePagination({
    count: Math.ceil(totalCount / itemsPerPage) || 1,
    onChange: (event, page) => onPageSelect(page - 1),
    page: page + 1,
  });

  return (
    <nav>
      <Grid container justifyContent="center" alignItems="center">
        {map(({ page, type, selected, ...item }) => {
          let children = null;

          if (type === "start-ellipsis" || type === "end-ellipsis") {
            children = "…";
          } else if (type === "page") {
            children = (
              <IconButton
                size="small"
                classes={{
                  sizeSmall: classes.pageButton,
                }}
                aria-label="page"
                {...item}
              >
                <PageIcon
                  classes={{
                    root: selected
                      ? classes.selectedPageIcon
                      : classes.pageIcon,
                  }}
                />
              </IconButton>
            );
          } else {
            children =
              type === "previous" ? (
                <IconButton
                  classes={{
                    root: classes.navButton,
                    disabled: classes.disabled,
                  }}
                  aria-label="previous-page"
                  {...item}
                  size="large"
                >
                  <PreviousIcon
                    classes={{ root: classes.navIcon }}
                    fontSize="large"
                  />
                </IconButton>
              ) : (
                <IconButton
                  classes={{
                    root: classes.navButton,
                    disabled: classes.disabled,
                  }}
                  aria-label="next-page"
                  {...item}
                  size="large"
                >
                  <NextIcon
                    classes={{ root: classes.navIcon }}
                    fontSize="large"
                  />
                </IconButton>
              );
          }

          return (
            <Grid item key={`${type}-${page}`}>
              {children}
            </Grid>
          );
        }, items)}
      </Grid>
    </nav>
  );
};

export default DotPagination;
